<template>
  <section class="promo_section">
    <div class="container default">
      <div class="section_content">
        <h1 class="page_title">Email Signature Generator</h1>
      </div>
    </div>
    <picture class="bg-block">
      <source srcset="../../../assets/promo_bg_320.svg" media="(max-width: 480px)">
      <source srcset="../../../assets/promo_bg_1024.webp" media="(max-width: 1024px)">
      <img src="../../../assets/promo_bg_1920.webp" alt="">
    </picture>
  </section>
</template>

<script>
export default {
  name: "PromoSection"
}
</script>

<style lang="scss" scoped>
  .promo_section {
    position: relative;
    min-height: 520px;
    width: 100%;
    margin: -80px 0 0 0;
    padding: 192px 0;
    .page_title {
      max-width: 470px;
      line-height: 1.13;
      font-size: 60px;
      font-weight: bold;
      text-shadow: 0 2px 16px rgba(67, 117, 173, 0.16);
      color: #ffffff;
    }
    .container {
      position: relative;
      z-index: 2;
    }
    .bg-block {
      position: absolute;
      left: 0; right: 0;
      bottom: 0; top: 0;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    @media only screen and (max-width: 1024px) {
      .section_content {
        display: flex;
        justify-content: center;
        width: 100%;
      }
      .page_title {
        text-align: center;
      }
    }
    @media only screen and (max-width: 640px) {
      min-height: 210px;
      margin: -60px 0 0 0;
      padding: 72px 0 54px 0;
      .page_title {
        line-height: 1.17;
        font-size: 36px;
      }
    }
  }
</style>